export const METRICS_CARD_PROGRESS_VIEW_DEFAULT_COLUMN_COUNT = 4

export const METRICS_CARD_PROGRESS_VIEW_COLUMN_COUNT_OPTIONS = [3, 4, 5, 6]
